export default {
  // Frontend errors
  generic: 'An error has happend',
  noResults: 'No results',

  // Web3 errors
  challengeNotSigned: 'Ownership challenge was not signed',
  couldntRetrieveHRContentURI: 'Couldn\'t retrieve high-resolution content URI',
  fetchingContractData: 'Error fetching contract data',
  fetchingTokensData: 'Error fetching tokens data',
  fetchingTokenData: 'Error fetching token data'

  // API errors

}
